export const createNewBasket = $localize`:CBasket|Create new basket upload button@@basketUploadModalCreateBtnText:Create a new basket`;
export const addToCurrentBasket = $localize`:CBasket|Add to current basket upload button@@basketUploadModalAddToCurrentBtnText:Add to current basket`;
